
import { defineComponent } from "vue";
import BaseSvg from "./BaseSvg.vue";

export default defineComponent({
  components: { BaseSvg },
  props: {
    message: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    type: String,
    closable: {
      type: Boolean,
      required: false,
    },
    id: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props, { emit }) {
    const close = () => emit("close", props.id);
    return { close };
  },
});
